var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from "mobx";
export const SKILL_EVAL_VERDICTS = ["correct", "partially_correct", "incorrect", "needs_review"];
export class GlobalAdminSkillEvalViewModel {
    constructor(container) {
        this.patientIdInput = "";
        this.reviewProjectId = "";
        this.reviewVerdict = "correct";
        this.reviewNotes = "";
        this.errorMessage = null;
        this.successMessage = null;
        this.manager = container.globalAdminSkillEvalManager;
        void this.manager.loadAllPartners();
    }
    get allPartners() {
        return this.manager.allPartners;
    }
    get runs() {
        return this.manager.runs;
    }
    get selectedRun() {
        return this.manager.selectedRun;
    }
    get loadingRuns() {
        return this.manager.loadingRuns;
    }
    get loadingMore() {
        return this.manager.loadingMore;
    }
    get hasMoreRuns() {
        return this.manager.hasMoreRuns;
    }
    get loadingDetail() {
        return this.manager.loadingDetail;
    }
    get submittingReview() {
        return this.manager.submittingReview;
    }
    get canLoadPatient() {
        return !this.loadingRuns && !!this.patientIdInput.trim();
    }
    setPatientId(v) {
        this.patientIdInput = v;
    }
    setReviewProjectId(v) {
        this.reviewProjectId = v;
    }
    setReviewVerdict(v) {
        this.reviewVerdict = v;
    }
    setReviewNotes(v) {
        this.reviewNotes = v;
    }
    setError(message) {
        this.errorMessage = message;
        if (message)
            this.successMessage = null;
    }
    setSuccess(message) {
        this.successMessage = message;
        if (message)
            this.errorMessage = null;
    }
    async loadRuns() {
        this.setError(null);
        const patientId = this.patientIdInput.trim();
        if (!patientId) {
            this.setError("Enter a patient ID");
            return;
        }
        try {
            await this.manager.loadRuns(patientId);
        }
        catch (e) {
            this.setError(this.messageOf(e));
        }
    }
    async loadPartnerRuns() {
        this.setError(null);
        if (!this.reviewProjectId) {
            this.setError("Select an AI Partner to review");
            return;
        }
        try {
            await this.manager.loadRunsByProject(this.reviewProjectId);
        }
        catch (e) {
            this.setError(this.messageOf(e));
        }
    }
    async loadMore() {
        try {
            await this.manager.loadMoreRuns();
        }
        catch (e) {
            this.setError(this.messageOf(e));
        }
    }
    async selectRun(runId) {
        this.setError(null);
        this.resetReviewForm();
        try {
            await this.manager.selectRun(runId);
        }
        catch (e) {
            this.setError(this.messageOf(e));
        }
    }
    resetReviewForm() {
        this.reviewVerdict = "correct";
        this.reviewNotes = "";
    }
    async submitReview() {
        const run = this.selectedRun;
        if (!run)
            return;
        this.setError(null);
        const req = {
            overallVerdict: this.reviewVerdict,
            notes: this.reviewNotes.trim() || undefined,
        };
        try {
            await this.manager.submitReview(run.id, req);
            this.setSuccess("Review submitted");
            this.setReviewNotes("");
        }
        catch (e) {
            this.setError(this.messageOf(e));
        }
    }
    messageOf(e) {
        return e instanceof Error ? e.message : String(e);
    }
}
__decorate([
    observable
], GlobalAdminSkillEvalViewModel.prototype, "patientIdInput", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalViewModel.prototype, "reviewProjectId", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalViewModel.prototype, "reviewVerdict", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalViewModel.prototype, "reviewNotes", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalViewModel.prototype, "errorMessage", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalViewModel.prototype, "successMessage", void 0);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "allPartners", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "runs", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "selectedRun", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "loadingRuns", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "loadingMore", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "hasMoreRuns", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "loadingDetail", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "submittingReview", null);
__decorate([
    computed
], GlobalAdminSkillEvalViewModel.prototype, "canLoadPatient", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "setPatientId", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "setReviewProjectId", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "setReviewVerdict", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "setReviewNotes", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "setError", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "setSuccess", null);
__decorate([
    action
], GlobalAdminSkillEvalViewModel.prototype, "resetReviewForm", null);
